// Slack's message ceiling is a familiar, bounded allowance for excerpts and
// chapter-sized coaching requests. Keep this shared by client and server so
// the composer can warn before the request boundary rejects the message.
export const ASSISTANT_V2_MAX_MESSAGE_CHARS = 40_000;
